import { lazy, Suspense, forwardRef } from 'react';
import { withStoreProvider } from './store';
import InputArea from './InputArea';

const LazyAIAgent = lazy(
  () =>
    import(
      /* webpackChunkName: "aiAgent" */
      /* webpackPrefetch: true */
      './AIAgent'
    ),
);

export default forwardRef(function AIAgent(props, ref) {
  return (
    <Suspense fallback={null}>
      <LazyAIAgent {...props} ref={ref} />
    </Suspense>
  );
});

export { default as NewChatButton } from './NewChatButton';
export { default as useDefaultFeedbackSettings } from './hooks/useDefaultFeedbackSettings';
export {
  MessageType,
  MessageContentType,
  createMessage,
  fetchJSONStream,
  fetchJsonBySSE,
} from './utils';

export { AGENT_ABORT_REASON } from './consts';

export const AIAgentInputArea = withStoreProvider(InputArea);
